export enum SearchScope {
  All = 'all',
  Filtered = 'filtered',
  Name = 'name',
}
